import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TopBarComponent from '../components/topBarComponent';
// import SideBarComponent from '../components/sidebarComponent';
import SideBarComponent from '../components/sidebarComponent/sideBarUserRights';
// import SideBarUSComponent from '../components/sidebarComponent/SideBarUSComponent';
import style from './MainLayout.module.css';
import { setNavigateFunction } from '../services/nevigationService';
import { SelectChangeEvent } from '@mui/material';
import { getMyProfile } from '../services/apiService';
import { User } from '../types';
// import { Regions, User } from '../types';
import { useClinic } from '../components/ClinicProvider';
// import disconnected from '../assets/images/disc.webp';
// import ImageWithSkeleton from '../components/customImageComponent';
import { usePatientContext } from '../components/patinetProvider';
import { usePatientContext as useSubPatientContext } from '../components/SubPatinetProvider';
import { getCurrentRegion } from '../services/userService';
import { VoiceNavigationProvider, VoiceActivationOverlay } from '../components/VoiceNavigation';
import LoaderComponent from '../components/loaderProvider/loaderComponet';

const MainLayout: React.FC = () => {

  function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T>();
  
    useEffect(() => {
      ref.current = value;
    }, [value]);
  
    return ref.current;
  }

  const navigate = useNavigate();

  const [user, setUser] = React.useState<User | null>(null);
  const [clinic, setClinic] = React.useState<string>('');
  const { setClinicId, ClinicId } = useClinic();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const previousClinic = usePrevious(ClinicId);
  const { removePatient } = usePatientContext();
  const { removeSubPatient } = useSubPatientContext();
  // const [selectedRegion, setSelectedRegion] = useState('Regions.US'); // Default to US
  

  useEffect(() => {  
    const fetchRegion = () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      getCurrentRegion().then((region) => {
       
        // setSelectedRegion(region || Regions.US );  
      });    
    };
      
    fetchRegion();
      
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    setClinic(event.target.value);
  };

  // Fetch user profile when component mounts
  React.useEffect(() => {
    getMyProfile().then((response: User) => {
      setUser(response);
      
      localStorage.setItem('user', JSON.stringify(response));
      localStorage.setItem('permissions', JSON.stringify(response.permissions));
    });
  }, []);

  // Set default clinic when the user data is loaded
  useEffect(() => {
    if (user?.clinics && user?.clinics.length > 0) {
      // Check if there's a previously selected clinic in localStorage
      const savedClinicId = localStorage.getItem('selectedClinicId');
      const savedClinicExists = savedClinicId && user.clinics.some(c => c.clinic_id.toString() === savedClinicId);
      
      if (savedClinicExists) {
        // Restore previously selected clinic
        setClinic(savedClinicId);
      } else {
        // Find clinic with is_default: true, fallback to first clinic
        const defaultClinic = user.clinics.find(c => c.is_default) || user.clinics[0];
        setClinic(defaultClinic.clinic_id.toString());
      }
    }
    setLoading(false); 
  }, [user]);

  // Persist selected clinic to localStorage
  useEffect(() => {
    if (clinic) {
      localStorage.setItem('selectedClinicId', clinic);
    }
  }, [clinic]);


  useEffect(() => {
    setClinicId(clinic);
  }, [clinic, setClinicId]);
  
  // Set the navigate function in the service
  useEffect(() => {
    setNavigateFunction(navigate, location);
  }, [navigate, location]);

  useEffect(() => {
    if (ClinicId && previousClinic) {
      removeSubPatient();
      removePatient();
      const autoPaths = ['/admin/appointments', '/admin/registration/patient-list', '/clinical/patients'];
      const path = location.pathname;
      
      if (!autoPaths.includes(path)) {
        if (path.includes('clinical')) {
          navigate('/clinical/patients');
        } else if (path.includes('appointments')) {
          navigate('/admin/appointments');
        } else {
          navigate('/admin/registration/patient-list');
        }
      }
    }
    // eslint-disable-next-line 
  }, [ClinicId, clinic, navigate]);

  if (loading) {
    return <LoaderComponent />; // Show a loading spinner while fetching user data
  }
  return (
    <VoiceNavigationProvider enableWakeWord={false}>
      <div className={style.main}>
        {user && <TopBarComponent handleChange={handleChange} clinic={clinic} user={user}/>}
        {/* {clinic?  */}
        <div className={style.content}>
          <div className={style.sidebar}>
            <SideBarComponent />
            {/* {selectedRegion === 'US' ? <SideBarUSComponent /> : <SideBarComponent />} */}
          </div>
          <main className={style.main_page}>
            <div className={style.outletContent}>
              <Outlet context={clinic}/>  {/* This renders the child routes like Dashboard */}
            </div>
          </main>
        </div>

        {/* Voice Activation Overlay - shows AiLoader when wake word detected */}
        <VoiceActivationOverlay />

        {/* Voice Log Viewer - shows speech recognition logs (hidden for now) */}
        {/* <VoiceLogViewer position="bottom-left" offset={{ x: 20, y: 20 }} /> */}
      </div>
    </VoiceNavigationProvider>
  );
};

export default MainLayout;